<template>
  <div class="users-preference">
    <div class="flex preference-description">
      <div class="box grow">
        <h5>User Settings</h5>
        <p>Configure user settings accross the application.</p>
      </div>
    </div>

    <div class="table-toolbar" v-if="usersListStatus === 'saved'">
      <table-toolbar
        v-if="visibleUserColumns"
        :key="users.key"
        :search-properties="visibleUserColumns"
        :total-search-properties="usersColumns"
        :search-data="users"
        :initial-tags="users.searchTags"
        :active-filter-data="activeFiltersData"
        :reload-component="users.reloadToolbar"
        :disable-search-box="disableSearchBox"
        @update-querydata="updateTableQueryData"
        @refresh-tabledata="refreshTableData"
        @update-columns-data="modifyColumnsData"
        @add-searchtags="addSearchTags"
        @deactivate-filter="deactivateFilter"
      >
        <div slot="left-toolbar-tools" class="filter-button-group">
          <span v-if="filterList.length">
            <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
              <el-input
                ref="customFilterInput"
                class="filter-input"
                v-if="btn.editFlag"
                placeholder="+Name"
                v-model="btn.name"
                @change.native.stop="handleFilterNameChange(btn)"
                @keyup.native.enter="handleFilterNameChange(btn)"
                @blur="handleFilterNameChange(btn)"
              ></el-input>
              <el-button
                v-else
                size="small"
                round
                :class="{'active': btn.active}"
                :id="btn.id"
                @click="changeState(btn)"
              >
                {{ btn.name}}
                <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                <span>
                  <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                  <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                </span>
                </el-tooltip>
              </el-button>
              
              <span v-if="btn.errFlag" class="filter-name-validator">{{filterErrMsg}}</span>
            </div>
          </span>
        </div>
        <div slot="local-actions">
          <el-button-group v-if="$allow('users', 'write')">
            <el-tooltip class="item" effect="dark" content="New User" placement="top" :enterable="false">
              <el-button type="text" class="cursor-pointer" @click="addUserModal">
                <i class="material-icons c-icon">person_add</i>
              </el-button>
            </el-tooltip>
          </el-button-group>
        </div>
      </table-toolbar>
    </div>

    <action-table-element
      v-if="$allow('users', 'write') && usersListStatus === 'saved'"
      :columns="visibleUserColumns"
      :table-data="users"
      :height-offset="200"
      :actions="tableActions"
      ref="usersTable"
      @update-record-count="recordCountHandler"
    ></action-table-element>

    <basic-table-element
      v-if="!$allow('users', 'write') && usersListStatus === 'saved'"
      :columns="visibleUserColumns"
      :table-data="users"
      :height-offset="200"
      ref="usersTable"
      @update-record-count="recordCountHandler"
    ></basic-table-element>

    <el-dialog title="Add User" :visible.sync="newUserdialogTableVisible">
      <el-form :model="newUser" :rules="newUser.validationRules" ref="newUserForm">
        <el-form-item label="First Name" prop="firstname">
          <el-input v-model.trim="newUser.firstname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Last Name" prop="lastname">
          <el-input v-model.trim="newUser.lastname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input v-model="newUser.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model.trim="newUser.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input type="password" v-model="newUser.password" autocomplete="off"></el-input>
          <el-progress
            class="password-strength-meter"
            :percentage="newUser.passwordStrengthScore"
            :color="newUser.passwordStrengthColor"
            :show-text="false"
          ></el-progress>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="confirmPassword">
          <el-input type="password" v-model="newUser.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Roles" prop="roles">
          <el-select v-model="newUser.roles" multiple filterable placeholder="Choose roles..">
            <el-option v-for="(item, idx) in userRoleList" :key="idx" :label="item.name" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Deactivate/Activate">
          <el-switch v-model="newUser.active"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div v-if="userFormError.length && !$_.isObject(userFormError)" class="error">
          <label>{{ userFormError }}</label>
        </div>
        <div v-else-if="!$_.isEmpty(userFormError) && $_.isObject(userFormError)" class="error">
          <label v-for="errObj in userFormError" :key="errObj">Error: {{ errObj }}</label>
        </div>
        <el-button
          @click="
            newUser.resetValidation()
            newUserdialogTableVisible = false
          "
          >Cancel</el-button
        >
        <el-button type="primary" @click="registerUser(newUser)">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Update User" :visible.sync="updateDialogTableVisible">
      <el-form :model="selectedUser" :rules="newUser.validationRules" ref="updateUserForm">
        <el-form-item label="First Name" prop="firstname">
          <el-input v-model.trim="selectedUser.firstname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Last Name" prop="lastname">
          <el-input v-model.trim="selectedUser.lastname" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Description" prop="description">
          <el-input v-model="selectedUser.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model.trim="selectedUser.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Roles" prop="roles">
          <el-select v-model="selectedUser.roles" multiple filterable placeholder="Choose roles..">
            <el-option v-for="item in userRoleList" :key="item.key" :label="item.name" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Deactivate/Activate">
          <el-switch v-model="selectedUser.active"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div v-if="userFormError.length && !$_.isObject(userFormError)" class="error">
          <label>{{ userFormError }}</label>
        </div>
        <div v-else-if="!$_.isEmpty(userFormError) && $_.isObject(userFormError)" class="error">
          <label v-for="errObj in userFormError" :key="errObj">Error: {{ errObj }}</label>
        </div>
        <el-button @click="updateDialogTableVisible = false">Cancel</el-button>
        <el-button type="primary" @click="updateUser(selectedUser)">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { usersMetaInfo } from '@/column-header/users/users-meta'
import User from '@/resources/models/User'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import BasicTableElement from '@/components/table/BasicTableElement.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import { ROLE_REQUEST } from '@/store/modules/role/role.type'
import { USER_LIST_REQUEST, USER_LIST_SUCCESS, USER_UPDATE, USER_CREATE_REQUEST, USERS_VIEW_PREFERENCES_REQ, SAVE_USERS_VIEW_PREFERENCES } from '@/store/modules/user/user.type'
import { PasswordScoreColorEnum } from '@/constants/password-score.constants'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import customFilterMixin from '@/mixins/customFilterMixin'

export default {
  name: 'Users',
  mixins: [customFilterMixin],
  data () {
    return {
      userColumnPrefs: {},
      tableName: "Users",
      users: [],
      newUserdialogTableVisible: false,
      updateDialogTableVisible: false,
      newUser: new User('id', {
        firstname: '',
        lastname: '',
        description: '',
        email: '',
        password: '',
        confirmPassword: '',
        passwordStrengthScore: 0,
        passwordStrengthColor: PasswordScoreColorEnum[0],
        active: true,
        roles: []
      }),
      selectedUser: {},
      userFormError: '',
      tableActions: [
        {
          name: 'edit',
          icon: 'c-icon el-icon-edit',
          tooltip: 'Edit User',
          rbac: {
            subject: 'users',
            operation: 'write'
          },
          actionHandler: selection => {
            this.userFormError = ''
            this.selectedUser = _.cloneDeep(selection.row)
            this.selectedUser.roles = _.map(this.selectedUser.roles, 'key')
            this.updateDialogTableVisible = true
            this.$nextTick(() => {
              if (!this.selectedUser.formRef) {
                this.selectedUser.setFormRef(this.$refs['updateUserForm'])
              }
            })
          }
        }
      ],
      totalUserColumns: usersMetaInfo.meta.columns,
      visibleUserColumns: [],
      tblId: 18
    }
  },
  methods: {
    getUsers (tableMetaData) {
      this.$store.dispatch(USER_LIST_REQUEST).then(users => {
        this.$set(this, 'users', users)
        this.$store.dispatch(USER_LIST_SUCCESS)
        this.setTableMetaData(tableMetaData)
      })
    },
    addUserModal () {
      this.userFormError = ''
      this.newUserdialogTableVisible = true
      this.$nextTick(() => {
        this.newUser.resetFields()
        if (!this.newUser.formRef) {
          this.newUser.setFormRef(this.$refs['newUserForm'])
        }
        this.newUser.resetValidation()
      })
    },
    registerUser (user) {
      this.userFormError = ''
      this.$refs['newUserForm'].validate(valid => {
        if (valid) {
          this.$store.dispatch(USER_CREATE_REQUEST, user).then(
            () => {
              this.getUsers()
              this.newUserdialogTableVisible = false
              this.newUser = new User('id', {
                firstname: '',
                lastname: '',
                description: '',
                email: '',
                password: '',
                confirmPassword: '',
                active: true,
                roles: []
              })
              this.newUser.setValidationRules()
              this.newUser.resetValidation()
            },
            errMsg => {
              let err = errMsg.data ? errMsg.data.message : 'Error occurred'
              this.$set(this, 'userFormError', err)
              console.log('error occurred')
            }
          )
        } else {
          this.$set(this, 'userFormError', 'Please populate all required fields.')
          return false
        }
      })
    },
    updateUser (user) {
      this.userFormError = ''
      this.$refs['updateUserForm'].validate(valid => {
        if (valid) {
          let mainUser = _.find(this.users.models, { id: user.id })
          this.$store
            .dispatch(USER_UPDATE, {
              id: user.id,
              firstname: user.firstname,
              lastname: user.lastname,
              description: user.description,
              active: user.active,
              roles: user.roles,
              email: user.email !== mainUser.email ? user.email : undefined // only send if email has been updated
            })
            .then(
              () => {
                this.getUsers()
                this.updateDialogTableVisible = false
              },
              errMsg => {
                this.userFormError = errMsg
                console.log('error occurred')
              }
            )
        } else {
          this.$set(this, 'userFormError', 'Please populate all required fields.')
          return false
        }
      })
    },
    updateTableQueryData () {
      if (this.$refs.usersTable) {
        this.$refs.usersTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.users.key = !this.users.key
      this.users.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.userColumnPrefs.userId = this.userProfile.id;
      this.userColumnPrefs.tblName = this.tableName;
      this.userColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.userColumnPrefs.tblId = 18; // For Mapping with database tables

      this.visibleUserColumns = this.users.updateVisibleColumns(this.usersColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_USERS_VIEW_PREFERENCES, this.userColumnPrefs)
        .then(data => {
          // store preferences in vuex
          this.userColumnPrefs.preferedCols = this.visibleUserColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.userColumnPrefs);
        })
    },
    callApi (tableMetaData) {
      this.getUsers(tableMetaData)
      this.$store.dispatch(ROLE_REQUEST)
      this.$nextTick(() => {
        this.newUser.setValidationRules()
      })
    },
    setTableMetaData (tableMetaData) {
      this.users.searchTags = tableMetaData.searchTags
      this.users.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.callApi(tableMetaData)
    },
    loadUserColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleUserColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(USERS_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleUserColumns = this.usersColumns.filter(col => {
              return this.usersPreferences.includes(col.label)
            })

            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.userColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleUserColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.userColumnPrefs);
    }
  },
  created () {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    this.callApi(tableMetaData)
    this.loadUserColumnPreferences()
  },
  computed: {
    usersColumns () {
      if (this.$allow('users', 'write')) {
        return this.totalUserColumns
      } else {
        return _.filter(this.totalUserColumns, col => {
          return _.indexOf(['active', 'roleNames'], col.name) < 0
        })
      }
    },
    ...mapGetters([
      'userStatus',
      'usersListStatus',
      'usersList',
      'userRoleList',
      'usersPreferences',
      'userPref',
      'userProfile'
    ])
  },
  components: {
    PageHeaders,
    ActionTableElement,
    TableToolbar,
    BasicTableElement
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';

h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.table-toolbar {
  /* margin-top: 20px; */

  button {
    max-height: 36px;
  }
}

.el-select {
  width: 100%;
}

.el-select-dropdown__item.selected:after {
  right: 0px !important;
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.el-dialog__wrapper {
  overflow: unset;
}

.el-dialog__wrapper >>> .el-dialog__body {
  overflow: auto;
  height: 365px;
}

.password-strength-meter {
  margin-top: 10px;
}

.users-preference {
  height: calc(100vh - 180px);
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
    position: relative;
    right: 115px;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/Users.vue